import { render, staticRenderFns } from "./DateDoctor.vue?vue&type=template&id=9588d798&"
import script from "./DateDoctor.vue?vue&type=script&lang=js&"
export * from "./DateDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports